export default __webpack_public_path__ + "static/media/41.85dbd990.jpg";